import { useTranslation } from '../localization/useTranslation'
import { IconWarn } from '../ui/icons'

/**
 * Shown when the widget is embedded without a `shopId` (via `tradeInConfig.shopId`/`.brandId`).
 * Without it we can't resolve the shop, its catalogue, or login — so this is a hard configuration
 * error for the integrator, not something the shopper can fix.
 */
export function ConfigError() {
  const { t } = useTranslation()
  return (
    <div className="center-note">
      <div className="config-error">
        <span className="config-error-icon">
          <IconWarn />
        </span>
        <h1>{t('config.title')}</h1>
        <p>{t('config.missingShop')}</p>
      </div>
    </div>
  )
}
